import React, { useState } from 'react';
import Navbar from '../components/navbar';
import forgotpass from '../icons/forgotpass.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from 'react-router-dom';
import './SignUp.css';

// Custom Slider Arrows
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return <div className={`${className} custom-arrow prev-arrow`} style={{ ...style }} onClick={onClick} />;
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return <div className={`${className} custom-arrow next-arrow`} style={{ ...style }} onClick={onClick} />;
};

const SignUp = () => {
  const [fname, setFname] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCpassword] = useState('');
  const [emailOtp, setEmailOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [emailOtpVerified, setEmailOtpVerified] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const handleSendOtp = () => {
    fetch(`${process.env.REACT_APP_API_URL}/Vendorsend-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
      .then((res) => {
        if (res.status === 200) {
          setOtpSent(true);
        
            toast.success('OTP sent successfully!');
        }else {
 
  toast.error('Error sending OTP');
}

      })
      .catch((err) => console.error('Error:', err));
  };

  const handleVerifyOtp = () => {
    fetch(`${process.env.REACT_APP_API_URL}/VendorVerify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, otp: emailOtp }),
    })
      .then((res) => {
        if (res.status === 200) {
          setEmailOtpVerified(true);
          finalSubmit();
        } else {
          setMessage('Invalid OTP');
        }
      })
      .catch((err) => console.error('Error:', err));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password || !cpassword) {
      setMessage('Please fill in all required fields.');
      return;
    }

    if (password !== cpassword) {
      setMessage('Passwords do not match.');
      return;
    }

    setFormSubmitted(true);
    handleSendOtp();
  };

 const finalSubmit = () => {
  if (!fname || !email || !number || !businessName || !password || !cpassword) {
    alert('Please fill in all required fields.');
    return;
  }

  fetch(`${process.env.REACT_APP_API_URL}/VendorRegister`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fname, email, number, businessName, password, cpassword }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === 'ok') {
           toast.success('🎉 Registration Successful!', { position: 'top-center' });

        localStorage.setItem('vendortoken', data.vendortoken);
        localStorage.setItem('vendorId', data.vendorId);

        setTimeout(() => {
          navigate('/Vendor/VendorSelectPlan');
        }, 2000);
      } else {
        toast.error('Registration failed: ' + data.message);
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      toast.error('Something went wrong. Please try again.');
    });
};

  return (
    <div>
     <ToastContainer position="top-center" autoClose={3000} />
      <Navbar />
      <div className="signup-page">
        <div className="signup-left">
          <h2>Connect with Global Buyers & Sellers</h2>
          <p>Newly launched platform designed to empower trade across industries.</p>
          <ul>
            <li><strong>Easy Registration:</strong> Start your journey in just a few steps.</li>
            <li><strong>Build Connections:</strong> Reach buyers through online & offline channels.</li>
            <li><strong>Smart Tools:</strong> Leverage AI to simplify and scale your business.</li>
          </ul>
          <button className="verify-btn">Join as a Verified Supplier</button>
        </div>

        {!formSubmitted ? (
          <div className="signup-right">
            <h3 className="mb-4 text-center">Create Account</h3>
            <form onSubmit={handleSubmit} className="signup-form">
              <div className="row">
                <div className="col-sm-6">
                  <input type="text" placeholder="First Name" className="form-control mb-3" onChange={(e) => setFname(e.target.value)} />
                </div>
                <div className="col-sm-6">
                  <input type="email" placeholder="Business Email*" className="form-control mb-3" onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="col-sm-6">
                  <input type="text" placeholder="Phone Number" className="form-control mb-3" onChange={(e) => setNumber(e.target.value)} />
                </div>
                <div className="col-sm-6">
                  <input type="text" placeholder="Business Name" className="form-control mb-3" onChange={(e) => setBusinessName(e.target.value)} />
                </div>
                <div className="col-sm-6">
                  <input type="password" placeholder="Create Password*" className="form-control mb-3" onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div className="col-sm-6">
                  <input type="password" placeholder="Confirm Password*" className="form-control mb-4" onChange={(e) => setCpassword(e.target.value)} />
                </div>
              </div>
              <button type="submit" className="btn btn-dark btn-submit w-100">Create Account</button>
            </form>
            <p className="mt-3 text-center">
              Already have an account? <Link to="/vendor/login">Login</Link>
            </p>
            <p className="text-center">
              Want to be a verified supplier? <Link to="#">Apply Here</Link>
            </p>
          </div>
        ) : (
          <div className="signup-right d-flex flex-column justify-content-center align-items-center p-5">
          
            <h3>OTP Verification</h3>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Enter OTP"
              onChange={(e) => setEmailOtp(e.target.value)}
            />
            <button className="btn btn-dark btn-submit w-100" onClick={handleVerifyOtp}>
              Verify & Proceed
            </button>
            {message && <p className="text-danger mt-3">{message}</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default SignUp;
